
export default [{
	path: '/users',
	component: () => import('@/components/users/List')
}]
